export class SetDataCatalogDatasetAccessControlModeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "DataCatalogDataset",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetDataCatalogDatasetAccessControlModeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
